import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, ActivityIndicator, Platform } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { Background, Card, Tile } from "components";

import { submitFeedback } from "state/modules/feedback";
import { getError, createError } from "state/modules/error";
import { isLoading } from "state/modules/loading";
import { POST_FEEDBACK } from "state/modules/feedback/types";
import {
  getSurveyLogo,
  getSurveyBackground,
} from "state/modules/survey/selectors";
import {
  DEFAULT_MESSAGES,
  LANGUAGE_CONFIGURATION_KEYS,
} from "consts/default-messages";

import { styles } from "./styles";

const isWeb = Platform.OS === "web";

class Submit extends Component {
  state = {
    current: new Date().getTime() / 1000,
    start: new Date().getTime() / 1000,
  };

  updateClock = () => {
    this.setState({ current: new Date().getTime() / 1000 });
  };

  componentDidMount = () => {
    if (__DEV__) {
      this.intervalID = setInterval(() => this.updateClock(), 1000);
    }
  };
  componentWillUnmount = () => {
    if (__DEV__) {
      clearInterval(this.intervalID);
    }
  };

  componentDidUpdate = prevProps => {
    if (!prevProps.isConnected && this.props.isConnected) {
      this.props.submitFeedback(true);
    }
    if (prevProps.isConnected && !this.props.isConnected) {
      this.props.createError({
        type: POST_FEEDBACK,
        message: "No Network",
      });
    }
  };

  render = () => {
    const { error, isConnected, background } = this.props;

    return (
      <Background style={styles.background} image={background}>
        <Card style={styles.card}>
          <View onLayout={() => this.forceUpdate()} style={styles.container}>
            {!isConnected
              ? this.renderNoConnection()
              : error && error !== "No Network"
              ? this.renderUploadingError()
              : this.renderUploadingProgress()}
          </View>
        </Card>
      </Background>
    );
  };

  renderNoConnection = () => {
    const { language_configuration } = this.props;
    const no_internet_connection =
      language_configuration &&
      LANGUAGE_CONFIGURATION_KEYS.no_internet_connection in
        language_configuration &&
      language_configuration[
        LANGUAGE_CONFIGURATION_KEYS.no_internet_connection
      ];
    return (
      <>
        <Icon
          name="alert-triangle"
          size={styles._errorIcon?.fontSize}
          color={styles._errorIcon?.color}
        />
        <Text style={styles.errorMessage}>
          {no_internet_connection || DEFAULT_MESSAGES.no_internet_connection}
        </Text>
      </>
    );
  };

  renderUploadingProgress = () => {
    const { language_configuration } = this.props;
    const submitting_feedback =
      language_configuration &&
      LANGUAGE_CONFIGURATION_KEYS.submitting_feedback in
        language_configuration &&
      language_configuration[LANGUAGE_CONFIGURATION_KEYS.submitting_feedback];
    const dont_close_tab =
      language_configuration &&
      LANGUAGE_CONFIGURATION_KEYS.dont_close_tab in language_configuration &&
      language_configuration[LANGUAGE_CONFIGURATION_KEYS.dont_close_tab];
    return (
      <>
        <ActivityIndicator size="large" color={styles._text?.color} />
        <Text style={styles.text}>{this.props.percentUploaded}%</Text>
        <Text style={styles.text}>
          {submitting_feedback || DEFAULT_MESSAGES.submitting_feedback}
          {isWeb && (dont_close_tab || DEFAULT_MESSAGES.dont_close_tab)}
        </Text>
        {__DEV__ && (
          <Text style={styles.text}>
            {Math.round(this.state.current - this.state.start)}
          </Text>
        )}
      </>
    );
  };

  renderUploadingError = () => {
    const { language_configuration } = this.props;
    const try_again =
      language_configuration &&
      LANGUAGE_CONFIGURATION_KEYS.try_again in language_configuration &&
      language_configuration[LANGUAGE_CONFIGURATION_KEYS.try_again];
    return (
      <>
        <>
          <Icon
            name="alert-triangle"
            size={styles._errorIcon?.fontSize}
            color={styles._errorIcon?.color}
          />
          <Text style={styles.errorIconLabel}>Error!</Text>
          <Text style={styles.errorMessage}>
            {try_again || DEFAULT_MESSAGES.try_again}
          </Text>
        </>
        <Tile
          text="Try again"
          style={styles.tiles}
          onPress={() => this.props.submitFeedback(true)}
          textStyle={styles.tilesText}
        />
        <Tile
          text="Try again without files"
          style={styles.tiles}
          onPress={() => this.props.submitFeedback(true, true)}
          textStyle={styles.tilesText}
        />
      </>
    );
  };
}

const mapDispatchToProps = {
  submitFeedback,
  createError,
};

const mapStateToProps = state => {
  const logo = getSurveyLogo(state);
  const background = getSurveyBackground(null, state);

  return {
    logo,
    background,
    error: getError(state, [POST_FEEDBACK]),
    isLoading: isLoading(state, [POST_FEEDBACK]),
    isConnected: state.network.isConnected,
    percentUploaded: state.feedback.percentUploaded,
    language_configuration: state.organization.language_configuration,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Submit);
